import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authPost } from './utils/authApi';

function Card({ title, children }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">{title}</h1>
        {children}
      </div>
    </div>
  );
}

export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    authPost('/verify-email', { token: params.get('token') || '' })
      .then(() => navigate('/dashboard'))
      .catch((e) => setError(e.message));
  }, [params, navigate]);

  return (
    <Card title="Confirming your email">
      {!error && <p className="text-gray-600" data-testid="verify-email-pending">One moment…</p>}
      {error && (
        <>
          <p className="text-red-600 mb-4" data-testid="verify-email-error">{error}</p>
          <Link to="/login" className="text-green-700 font-bold hover:underline" data-testid="verify-email-login-link">Back to log in</Link>
        </>
      )}
    </Card>
  );
}

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setError("Passwords don't match.");
    setBusy(true); setError('');
    try {
      await authPost('/reset-password', { token: params.get('token') || '', password: pw });
      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  const input = 'w-full border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-green-500';
  return (
    <Card title="Choose a new password">
      <form onSubmit={submit} className="space-y-3" data-testid="reset-password-form">
        <input className={input} type="password" placeholder="New password (8+ characters)" minLength={8} required value={pw} onChange={(e) => setPw(e.target.value)} autoComplete="new-password" data-testid="reset-password-input" />
        <input className={input} type="password" placeholder="Repeat new password" minLength={8} required value={pw2} onChange={(e) => setPw2(e.target.value)} autoComplete="new-password" data-testid="reset-password-confirm-input" />
        {error && <p className="text-sm text-red-600" data-testid="reset-password-error">{error}</p>}
        <button type="submit" disabled={busy} className="w-full bg-gray-900 hover:bg-black text-white rounded-lg px-6 py-3 font-bold disabled:opacity-60" data-testid="reset-password-submit-btn">
          {busy ? 'Saving…' : 'Save new password'}
        </button>
        <p className="text-xs text-gray-500">This signs you out everywhere else.</p>
      </form>
    </Card>
  );
}
